module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-08-18 at 7.27.42 AM.83968b15.png";